export interface Risk {
  risk: string;
  control: string;
  owners: string;
  anchor: string;
}

export const risks: Risk[] = [
  {
    risk: 'Non-determinism & reproducibility',
    control:
      'Deterministic harness around probabilistic core; full trace capture',
    owners: 'SRE + Platform',
    anchor: 'NIST AI RMF Measure',
  },
  {
    risk: 'Hallucination & grounding',
    control:
      'RAG with provenance, citation-required outputs, eval thresholds',
    owners: 'Product + ML',
    anchor: 'ISO 42001 §8',
  },
  {
    risk: 'Prompt injection (direct & indirect)',
    control: 'Prompt firewall, CSP on tool output, allow-listed sources',
    owners: 'Security',
    anchor: 'OWASP LLM01 / ASI01',
  },
  {
    risk: 'Tool misuse / confused deputy',
    control:
      'Per-tool scoped tokens, MCP server portals, human approval on destructive actions',
    owners: 'Security + Platform',
    anchor: 'OWASP ASI02',
  },
  {
    risk: 'Agent identity at scale',
    control:
      'OAuth for agents, per-agent service identities, short-lived scoped tokens',
    owners: 'IAM',
    anchor: 'NIST AI RMF Govern',
  },
  {
    risk: 'Shadow AI / Shadow MCP',
    control: 'Egress controls, AI Gateway logging, sanctioned tooling',
    owners: 'Security + IT',
    anchor: 'AU VAISS G1, G6',
  },
  {
    risk: 'Cost runaway',
    control: 'Per-agent token budgets, model routing, circuit breakers',
    owners: 'FinOps + Eng',
    anchor: 'FinOps Foundation',
  },
  {
    risk: 'Model supply-chain',
    control:
      'AIBOM (CycloneDX ML-BOM / SPDX 3.0), signed model artefacts',
    owners: 'Security + Legal',
    anchor: 'EU AI Act Art.11; OWASP AIBOM',
  },
  {
    risk: 'Regulatory exposure',
    control: 'AI inventory, risk classification, conformity assessment',
    owners: 'Legal + Risk',
    anchor: 'EU AI Act; ISO 42001; NIST AI RMF; AU VAISS',
  },
  {
    risk: 'Skill atrophy / over-reliance',
    control: 'Agent-off pairing, post-mortems, deliberate practice',
    owners: 'Eng leadership',
    anchor: '—',
  },
  {
    risk: 'Vendor lock-in',
    control:
      'Model-agnostic gateway, eval portability, open weights as fallback',
    owners: 'Architecture',
    anchor: '—',
  },
  {
    risk: 'Cascading agent failure',
    control: 'Per-hop budgets, circuit breakers, idempotency keys',
    owners: 'SRE',
    anchor: 'OWASP ASI05',
  },
  {
    risk: 'IP / copyright in generated code',
    control:
      'Provenance scanning, license filters, indemnified providers',
    owners: 'Legal + Eng',
    anchor: '—',
  },
  {
    risk: 'Trust calibration',
    control:
      'Graduated autonomy ladder, eval-backed confidence scoring',
    owners: 'Product',
    anchor: 'NIST AI RMF Manage',
  },
  {
    risk: 'Eval maturity gap',
    control:
      'Treat evals as the new test pyramid; grow from production failures',
    owners: 'Engineering',
    anchor: '(internal)',
  },
];
